import { Property, SiteGeo, EFFICIENCY_COLOR, EFFICIENCY_THRESHOLD } from './mock-data';

export const getEfficiencyColor = (efficiency: number) => {
  // EUI values: lower is better
  if (efficiency <= EFFICIENCY_THRESHOLD[0]) return EFFICIENCY_COLOR[0]; // ZEB (best)
  if (efficiency <= EFFICIENCY_THRESHOLD[1]) return EFFICIENCY_COLOR[1]; // ECON
  if (efficiency <= EFFICIENCY_THRESHOLD[2]) return EFFICIENCY_COLOR[2]; // HEPS
  if (efficiency <= EFFICIENCY_THRESHOLD[3]) return EFFICIENCY_COLOR[3]; // BEC
  return EFFICIENCY_COLOR[4]; // REF (worst)
};

export const getEfficiencyCategory = (efficiency: number) => {
  // Returns the category label based on EUI value
  if (efficiency <= EFFICIENCY_THRESHOLD[0]) return 'ZEB';
  if (efficiency <= EFFICIENCY_THRESHOLD[1]) return 'ECON';
  if (efficiency <= EFFICIENCY_THRESHOLD[2]) return 'HEPS';  
  if (efficiency <= EFFICIENCY_THRESHOLD[3]) return 'BEC';
  return 'REF';
};

export const mapSitetoSiteGeo = (site: Property): SiteGeo & { province: string; region: string } => {
  const efficiencyColor = getEfficiencyColor(site.efficiency ?? 0);
  const efficiencyCategory = getEfficiencyCategory(site.efficiency ?? 0);
  const isOffline = !site.isOnline;
  
  return {
    id: site.id,
    code: site.code,
    name: site.name,
    province: site.province,
    region: site.region,
    lat: site.lat,
    lon: site.lon,
    realLat: site.lat,
    realLon: site.lon,
    value: site.efficiency !== null ? Math.round(site.efficiency).toString() : '-',
    color: efficiencyColor + '20', // Add transparency
    image: site.image || '/src/assets/site_logo/brand_logo.png',
    backgroundColor: '#ffffff',
    statusColor: isOffline ? '#9CA3AF' : efficiencyColor,
    imageCSS: isOffline ? 'grayscale(100%)' : 'none',
    offlineIcon: isOffline ? 'block' : 'none',
    disconnectIconDisplay: isOffline ? 'block' : 'none',
    valueColor: isOffline ? '#6B7280' : efficiencyColor,
    updatedAt: site.lastUpdated ?? '',
    category: efficiencyCategory,
    hasAlarm: site.hasAlarm,
  };
};